import {
  Breadcrumb,
  BreadcrumbItem,
  // BreadcrumbLink,
  BreadcrumbList, BreadcrumbPage,
  // BreadcrumbSeparator
} from "@/components/ui/breadcrumb.tsx";
// import IconHome from "@/assets/icons/ico-home.svg?react"

interface BreadCrumbProps {
  current: string;
  parent?: string;
  grandParent?: string;
}

export const BreadCrumb = ({ current }: BreadCrumbProps) => {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {/* 홈 */}
        {/*<BreadcrumbItem>*/}
        {/*  <BreadcrumbLink href="/">*/}
        {/*    <IconHome />*/}
        {/*  </BreadcrumbLink>*/}
        {/*</BreadcrumbItem>*/}

        {/* Grand Parent */}
        {/*{grandParent && (*/}
        {/*  <>*/}
        {/*    <BreadcrumbSeparator />*/}
        {/*    <BreadcrumbItem>*/}
        {/*      <BreadcrumbPage>{grandParent}</BreadcrumbPage>*/}
        {/*    </BreadcrumbItem>*/}
        {/*  </>*/}
        {/*)}*/}

        {/* Parent */}
        {/*{parent && (*/}
        {/*  <>*/}
        {/*    <BreadcrumbSeparator />*/}
        {/*    <BreadcrumbItem>*/}
        {/*      <BreadcrumbPage>{parent}</BreadcrumbPage>*/}
        {/*    </BreadcrumbItem>*/}
        {/*  </>*/}
        {/*)}*/}

        {/* Current */}
        {/*<BreadcrumbSeparator />*/}
        <BreadcrumbItem>
          <BreadcrumbPage>{current}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}